// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import ApartmentDetail from './pages/ApartmentDetail';
import Footer from './components/Footer';
import SignInUp from './components/SignInUp';
import MyInfo from './pages/MyInfo';
import Price from './pages/Price';
import AptMetrix from './pages/AptMetrix';
import ApartmentSearch from './pages/ApartmentSearch';
import { useAppContext } from './context/AppContext';
import Success from './components/Success';
import Cancel from './components/Cancel';
import ProtectedRoute from './components/ProtectedRoute';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Watchlist from './pages/Watchlist';
import { AptMetrixProvider } from './context/aptmetrix';
import ErrorBoundary from './components/ErrorBoundary';


function App() {
  const { session } = useAppContext();

  return (
    <Router>
      <div className={`App`}>
        <Header />
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metrix" element={
            <AptMetrixProvider>
              <ProtectedRoute element={<AptMetrix />} session={session} />
            </AptMetrixProvider>
          } />
          <Route path="/filter" element={
            <ProtectedRoute element={<ApartmentSearch />} session={session} />
          } />
          <Route path="/watchlist" element={
            <ProtectedRoute element={<Watchlist />} session={session} />
          } />
          <Route path="/my" element={<MyInfo />} />
          <Route path="/price" element={<Price />} />
          <Route path="/apartment/:aptNo" element={
            <ProtectedRoute element={<ApartmentDetail />} session={session} />
          } />
          <Route path="/sign" element={<SignInUp />} />
          <Route path="/success" element={session?.user ? <Success /> : <Home />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/tos" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* 404 페이지 및 에러 처리를 위한 fallback 라우트 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>
        <hr />
        <Footer />
      </div>
    </Router>
  )
}

export default App;
